import { StarrableFieldsFragment } from "components/engagement/star/graphql/StarrableFieldsFragment";
import gql from "graphql-tag";

export const AddStarMutation = gql`
  mutation AddStar($input: AddStarInput!) {
    addStar(input: $input) {
      ...StarrableFields
    }
  }
  ${StarrableFieldsFragment}
`;
